import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { GROUPAGE_OPTIONS } from "@/constants/business";
import { useDialogs } from "@/context/DialogsContext";
import VolumeCalculator from "@/components/VolumeCalculator";

export default function GroupageSection() {
  const { requestEstimate } = useDialogs();

  return (
    <section id="groupage" data-testid="groupage-section" className="py-14 md:py-20 px-4 md:px-8 bg-graylight">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Groupage</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3 mb-3">
            Payez uniquement l'espace dont vous avez besoin
          </h2>
          <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
            Lorsque plusieurs transports vont vers une même zone, Express Delivery peut mutualiser le trajet. Vous réservez uniquement le volume nécessaire dans le camion, sous réserve de disponibilité et de compatibilité des dates.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 md:gap-5 mb-5">
          {GROUPAGE_OPTIONS.map((option, i) => (
            <motion.div
              key={option.key}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.06 }}
              data-testid={`groupage-option-${option.key}`}
              className="bg-navy rounded-2xl p-6 md:p-7"
            >
              <option.icon className="w-7 h-7 text-orange mb-4" />
              <h3 className="font-heading font-bold text-xl text-white mb-4">{option.title}</h3>
              <ul className="space-y-2.5">
                {option.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2 text-sm text-white/80">
                    <CheckCircle2 className="w-4 h-4 text-orange shrink-0 mt-0.5" /> {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <VolumeCalculator />

        <div className="mt-8">
          <Button
            data-testid="groupage-cta"
            onClick={() => requestEstimate({ type: "Groupage", source: "groupage-verifier" })}
            className="bg-orange hover:bg-orange-hover text-white rounded-full px-8 py-6 font-semibold transition-transform hover:-translate-y-0.5 shadow-lg shadow-orange/20"
          >
            Vérifier le groupage
          </Button>
        </div>
      </div>
    </section>
  );
}
